import { IOnePaymentItem, IOneTimePaymentItem, ItemTypeEnum } from '../model';

export const adapter = (item: IOnePaymentItem): IOneTimePaymentItem => {
  return {
    type: ItemTypeEnum.one_payment,
    plan_id: String(item.id),
    disabled: false,
    display: {
      name: item.name,
      sport_category: 'Specials',
    },
    current: item.current,
    prices: {
      once: {
        unit_amount: item.base_price,
        price_id: String(item.id)
      },
    },
  }
}
